<template>
  <p class="onfocus__queries-header q-text-muted q-col-12 q-mt-1 q-mb-0 q-fw-semibold q-text-start">{{ header }}</p>
</template>
<script setup>
import { defineProps } from 'vue'

defineProps(['header'])

</script>
<style scoped>
a {
  cursor: pointer;
}
</style>
